// About Reducer

export default (state = {}, action) => {
    switch (action.type) {
        case 'ADD_ABOUT_DATA':
        return {
            ...state,
            page_title:action.data.page_title,
            subtitle:action.data.subtitle,
            page_content:action.data.page_content,
            dataIn:true
        };
        default:
        return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/about.js